import React from 'react';

export default function JesterCapSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Headband */}
      <rect x="6" y="26" width="28" height="5" rx="1.5" fill="#FFD54F" />
      <rect x="6" y="26" width="28" height="1.5" fill="#FFECB3" opacity="0.7" />
      {/* Left point - purple */}
      <path d="M8 26 L4 10 L14 22 Z" fill="#7B1FA2" />
      {/* Center point - red */}
      <path d="M14 26 L20 4 L26 26 Z" fill="#C62828" />
      {/* Right point - purple */}
      <path d="M26 22 L36 10 L32 26 Z" fill="#7B1FA2" />
      {/* Bells */}
      <circle cx="4" cy="10" r="2.5" fill="#FFD54F" />
      <circle cx="4" cy="10" r="1" fill="#FF8F00" />
      <circle cx="20" cy="4" r="2.5" fill="#FFD54F" />
      <circle cx="20" cy="4" r="1" fill="#FF8F00" />
      <circle cx="36" cy="10" r="2.5" fill="#FFD54F" />
      <circle cx="36" cy="10" r="1" fill="#FF8F00" />
      {/* Subtle shading on points */}
      <path d="M14 26 L20 4 L20 26 Z" fill="white" opacity="0.08" />
      <path d="M26 22 L36 10 L33 22 Z" fill="white" opacity="0.08" />
    </svg>
  );
}
